<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("PLACEHOLDERS.update_delivery_data") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #F7941E">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <form @submit.prevent="validateFormInputs">
        <div class="row">
          <h2>
            {{ $t("PLACEHOLDERS.personalData") }}
          </h2>
          <base-image-upload-input
            v-if="data.user_image"
            col="12"
            identifier="service_image"
            :placeholder="$t('PLACEHOLDERS.user_image')"
            :preSelectedImage="data.user_image"
            disabled
          />

          <!-- Start:: Ar Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.firstdelevaryName')"
            v-model.trim="data.first_name"
            disabled
          />
          <!-- End:: Ar Name Input -->

          <!-- Start:: En Name Input -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.lastdelevaryName')"
            v-model.trim="data.last_name"
            disabled
          />
          <base-input
            v-if="data.email"
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.email')"
            v-model.trim="data.email"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.phone')"
            v-model.trim="data.phone"
            disabled
          />

          <h2>
            {{ $t("PLACEHOLDERS.bankData") }}
          </h2>
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_name')"
            v-model.trim="data.bank_name"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bank_num')"
            v-model.trim="data.bank_num"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.iban')"
            v-model.trim="data.iban"
            disabled
          />
          <base-input
            col="6"
            type="text"
            :placeholder="$t('PLACEHOLDERS.bersonal_id')"
            v-model.trim="data.bersonal_id"
            disabled
          />
          <!-- End:: En Name Input -->

          <h2>
            {{ $t("PLACEHOLDERS.vichelData") }}
          </h2>

          <!-- Start:: type Input -->
          <base-input
            col="12"
            type="text"
            :placeholder="$t('PLACEHOLDERS.vichelType')"
            v-model.trim="data.vichelTypeTrans"
            disabled
          />
          <!-- End:: type Input -->

          <!-- Start:: count_stores Input -->
          <div class="row" v-if="data.vichelType !== 'bicycle'">
            <base-input
              col="12"
              type="text"
              :placeholder="$t('PLACEHOLDERS.vichelPlate')"
              v-model.trim="data.vichelPlate"
              disabled
            />
            <base-image-upload-input
              col="6"
              identifier="service_image"
              :placeholder="$t('PLACEHOLDERS.driving_license_image_face')"
              :preSelectedImage="data.driving_license_image_face"
              disabled
            />
            <base-image-upload-input
              col="6"
              identifier="service_image"
              :placeholder="$t('PLACEHOLDERS.driving_license_image_back')"
              :preSelectedImage="data.driving_license_image_back"
              disabled
            />
            <base-image-upload-input
              col="6"
              identifier="service_image"
              :placeholder="$t('PLACEHOLDERS.vehicle_license_image_face')"
              :preSelectedImage="data.vehicle_license_image_face"
              disabled
            />
            <base-image-upload-input
              col="6"
              identifier="service_image"
              :placeholder="$t('PLACEHOLDERS.vehicle_license_image_back')"
              :preSelectedImage="data.vehicle_license_image_back"
              disabled
            />
          </div>
          <!-- End:: count_stores Input -->
        </div>
      </form>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
export default {
  name: "CreateArea",

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      // Start:: Data Collection To Send
      data: {
        user_image: null,
        first_name: null,
        last_name: null,
        email: null,
        phone: null,
        bank_name: null,
        bank_num: null,
        iban: null,
        bersonal_id: null,
        vichelType: null,
        vichelTypeTrans: null,
        vichelPlate: null,
        driving_license_image_face: null,
        driving_license_image_back: true,
        vehicle_license_image_face: true,
        vehicle_license_image_back: true,
      },
      // End:: Data Collection To Send
    };
  },

  methods: {
    // Start:: Get Data To Edit
    async getDataToEdit() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `update-deliveies/show/${this.$route.params.id}`,
        });
        // Start:: Set Data
        this.data.user_image = res.data.data.UpdateRequest.avatar;
        this.data.first_name = res.data.data.UpdateRequest.first_name;
        this.data.last_name = res.data.data.UpdateRequest.last_name;
        this.data.email = res.data.data.UpdateRequest.email;
        this.data.phone = res.data.data.UpdateRequest.mobile;
        this.data.bank_name = res.data.data.UpdateRequest.bnak?.name;
        this.data.bank_num = res.data.data.UpdateRequest.account_number;
        this.data.iban = res.data.data.UpdateRequest.iban;
        this.data.bersonal_id = res.data.data.UpdateRequest.id_number;
        this.data.vichelType = res.data.data.UpdateRequest.vehicle_type;
        this.data.vichelTypeTrans =
          res.data.data.UpdateRequest.vehicle_type_trans;
        this.data.vichelPlate =
          res.data.data.UpdateRequest.vehicle_plate_number;
        this.data.driving_license_image_face =
          res.data.data.UpdateRequest.driving_license_image_face;
        this.data.driving_license_image_back =
          res.data.data.UpdateRequest.driving_license_image_back;
        this.data.vehicle_license_image_face =
          res.data.data.UpdateRequest.vehicle_license_image_face;
        this.data.vehicle_license_image_back =
          res.data.data.UpdateRequest.vehicle_license_image_back;
        // End:: Set Data
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
  },

  async created() {
    // Start:: Fire Methods
    this.getDataToEdit();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>
